import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    list: {
        isLoading: true,
        suppliers: [],
        showAddSupplier: false,
        showEditSupplier: false,
        error: "",
        currentPage: 1,
        pageCount: 0,
        isDeleteSupplier: false,
        supplierId: null,
    },
    editSupplier: {
        name: {
            value: "",
            error: "",
            showError: "",
        },
        contacts: [],
        // FirstName: {
        //     value: "",
        //     error: "",
        //     showError: "",
        // },
        // LastName: {
        //     value: "",
        //     error: "",
        //     showError: "",
        // },
        // Email: {
        //     value: "",
        //     error: "",
        //     showError: "",
        // },
        street: {
            value: "",
            error: "",
            showError: "",
        },
        city: {
            value: "",
            error: "",
            showError: "",
        },
        zipcode: {
            value: "",
            error: "",
            showError: "",
        },
        supplierState: {
            value: "",
            error: "",
            showError: "",
        },
        error: {
            value: "",
            error: "",
            showError: "",
        },
        emailTakenError: "",
        emailDuplicateError: false
    },
    addSupplier: {
        name: {
            value: "",
            error: "",
            showError: "",
        },
        // FirstName: {
        //     value: "",
        //     error: "",
        //     showError: "",
        // },
        // LastName: {
        //     value: "",
        //     error: "",
        //     showError: "",
        // },
        // Email: {
        //     value: "",
        //     error: "",
        //     showError: "",
        // },
        contacts: [
            {
                FirstName: {
                    value: "",
                    error: "",
                    showError: ""

                },
                LastName: {
                    value: "",
                    error: "",
                    showError: ""

                },
                Email: {
                    value: "",
                    error: "",
                    showError: ""

                }
            }
        ],
        street: {
            value: "",
            error: "",
            showError: "",
        },
        city: {
            value: "",
            error: "",
            showError: "",
        },
        zipcode: {
            value: "",
            error: "",
            showError: "",
        },
        supplierState: {
            value: "",
            error: "",
            showError: "",
        },
        error: {
            value: "",
            error: "",
            showError: "",
        },
        emailTakenError: "",
        emailDuplicateError: false
    }
}

const namespacers = {
    listSuppliers: createNamespacer("SUPPLIERS_LIST"),
    editSupplier: createNamespacer("EDIT_SUPPLIER"),
    addSupplier: createNamespacer("ADD_SUPPLIER"),
}

const listReducer = createReducer(initialState.list, {
    "SET_SHOW_EDIT_SUPPLIER": (state, action) => {
        return {
            ...state,
            showEditSupplier: action.payload.value,
        }
    },
    "SET_SHOW_ADD_SUPPLIER": (state, action) => {
        return {
            ...state,
            showAddSupplier: action.payload.value,
        }
    },
    [namespacers.listSuppliers("SET_DELETE_SUPPLIER")]: (state, action) => {
        return {
            ...state,
            isDeleteSupplier: action.payload.value,
        }
    },
    [namespacers.listSuppliers("SET_SUPPLIER_ID")]: (state, action) => {
        return {
            ...state,
            supplierId: action.payload.id,
        }
    },
    [namespacers.listSuppliers("SET_SUPPLIERS")]: (state, action) => {
        return {
            ...state,
            suppliers: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [namespacers.listSuppliers("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.listSuppliers("SET_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [namespacers.listSuppliers("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    }
});

const editSupplierReducer = createReducer(initialState.editSupplier, {
    [namespacers.editSupplier("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.editSupplier("SET_SUPPLIER_NAME")]: (state, action) => {
        return {
            ...state,
            name: {
                ...state.name,
                value: action.payload.value,
            },

        }
    },
    [namespacers.editSupplier("SET_SUPPLIER_FIRST_NAME")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.editSupplier("SET_SUPPLIER_LAST_NAME")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.editSupplier("SET_SUPPLIER_EMAIL")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.editSupplier("ADD_SUPPLIER_CONTACT")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.editSupplier("REMOVE_SUPPLIER_CONTACT")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.editSupplier("SET_STREET")]: (state, action) => {
        return {
            ...state,
            street: {
                ...state.street,
                value: action.payload.value,
            },
        }

    },
    [namespacers.editSupplier("SET_CITY")]: (state, action) => {
        return {
            ...state,
            city: {
                ...state.city,
                value: action.payload.value,
            },
        }
    },
    [namespacers.editSupplier("SET_STATE")]: (state, action) => {
        return {
            ...state,
            supplierState: {
                ...state.supplierState,
                value: action.payload.value,
            },
        }
    },
    [namespacers.editSupplier("SET_ZIPCODE")]: (state, action) => {
        return {
            ...state,
            zipcode: {
                ...state.zipcode,
                value: action.payload.value,
            },

        }
    },
    [namespacers.editSupplier("SET_SUPPLIER_FIELD_ERRORS")]: (state, action) => {

        let contactsArray = state.contacts

        action.payload.value.forEach((contact) => {
            if (contact.value === 'FirstName') {
                contactsArray[contact.key].FirstName.error = contact.errorMessage
                contactsArray[contact.key].FirstName.showError = contact.errorMessage
            }
            if (contact.value === 'LastName') {
                contactsArray[contact.key].LastName.error = contact.errorMessage
                contactsArray[contact.key].LastName.showError = contact.errorMessage
            }
            if (contact.value === 'Email') {
                contactsArray[contact.key].Email.error = contact.errorMessage
                contactsArray[contact.key].Email.showError = contact.errorMessage
            }
        })

        return {
            ...state,
            contacts: [
                ...contactsArray
            ]
        }
    },
    [namespacers.editSupplier("SET_EMAIL_TAKEN_FIELD_ERRORS")]: (state, action) => {
        return {
            ...state,
            emailTakenError: action.payload.value
        }
    },
    [namespacers.editSupplier("SET_EMAIL_DUPLICATE_ERRORS")]: (state, action) => {
        return {
            ...state,
            emailDuplicateError: action.payload.value
        }
    },
    [namespacers.editSupplier("SET_SUPPLIER_NAME_FIELD_ERRORS")]: (state, action) => {
        return {
            ...state,
            name: {
                ...state.name,
                error: action.payload.value,
                showError: action.payload.value
            }
        }
    },
    [namespacers.editSupplier("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.editSupplier,
        }
    },
    [namespacers.editSupplier("LOAD_DATA")]: (state, action) => {
        const responseMapping = {
            name: 'name',
            // FirstName: 'first_name',
            // LastName: 'last_name',
            // Email: 'email',
            // contacts: 'contacts',
            street: 'street',
            city: 'city',
            supplierState: 'state',
            zipcode: 'zipcode',
        }

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                return [key, {
                    ...state[key],
                    value: action.payload.value[responseKey] || ""
                }]
            })
        )

        let supplierContacts = action.payload.value['contacts'].map((contact) => {
            return {
                ContactId: contact.contact_id,
                FirstName: {
                    value: contact.first_name,
                    error: "",
                    showError: "",
                },
                LastName: {
                    value: contact.last_name,
                    error: "",
                    showError: "",

                },
                Email: {
                    value: contact.email,
                    error: "",
                    showError: ""

                },
                deleted: false
            }
        })


        return {
            ...state,
            ...loadedFields,
            contacts: [
                ...supplierContacts
            ]
        }

    },
    [namespacers.editSupplier("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }

    },
})

const addSupplierReducer = createReducer(initialState.addSupplier, {
    [namespacers.addSupplier("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.addSupplier("SET_SUPPLIER_NAME")]: (state, action) => {
        return {
            ...state,
            name: {
                ...state.name,
                value: action.payload.value,
            },

        }
    },
    [namespacers.addSupplier("ADD_SUPPLIER_CONTACT")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.addSupplier("REMOVE_SUPPLIER_CONTACT")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.addSupplier("SET_SUPPLIER_FIRST_NAME")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.addSupplier("SET_SUPPLIER_LAST_NAME")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.addSupplier("SET_SUPPLIER_EMAIL")]: (state, action) => {
        return {
            ...state,
            contacts: [
                ...action.payload.contactArray
            ]
        }
    },
    [namespacers.addSupplier("SET_STREET")]: (state, action) => {
        return {
            ...state,
            street: {
                ...state.street,
                value: action.payload.value,
            },
        }

    },
    [namespacers.addSupplier("SET_CITY")]: (state, action) => {
        return {
            ...state,
            city: {
                ...state.city,
                value: action.payload.value,
            },
        }
    },
    [namespacers.addSupplier("SET_STATE")]: (state, action) => {
        return {
            ...state,
            supplierState: {
                ...state.supplierState,
                value: action.payload.value,
            },
        }
    },
    [namespacers.addSupplier("SET_ZIPCODE")]: (state, action) => {
        return {
            ...state,
            zipcode: {
                ...state.zipcode,
                value: action.payload.value,
            },

        }
    },
    [namespacers.addSupplier("SET_SUPPLIER_FIELD_ERRORS")]: (state, action) => {

        let contactsArray = state.contacts

        action.payload.value.forEach((contact) => {
            if (contact.value === 'FirstName') {
                contactsArray[contact.key].FirstName.error = contact.errorMessage
                contactsArray[contact.key].FirstName.showError = contact.errorMessage
            }
            if (contact.value === 'LastName') {
                contactsArray[contact.key].LastName.error = contact.errorMessage
                contactsArray[contact.key].LastName.showError = contact.errorMessage
            }
            if (contact.value === 'Email') {
                contactsArray[contact.key].Email.error = contact.errorMessage
                contactsArray[contact.key].Email.showError = contact.errorMessage
            }
        })

        return {
            ...state,
            contacts: [
                ...contactsArray
            ]
        }
    },
    [namespacers.addSupplier("SET_EMAIL_TAKEN_FIELD_ERRORS")]: (state, action) => {
        return {
            ...state,
            emailTakenError: action.payload.value
        }
    },
    [namespacers.addSupplier("SET_EMAIL_DUPLICATE_ERRORS")]: (state, action) => {
        return {
            ...state,
            emailDuplicateError: action.payload.value
        }
    },
    [namespacers.addSupplier("SET_SUPPLIER_NAME_FIELD_ERRORS")]: (state, action) => {
        return {
            ...state,
            name: {
                ...state.name,
                error: action.payload.value,
                showError: action.payload.value
            }
        }
    },
    [namespacers.addSupplier("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.addSupplier,
            contacts: [
                {
                    FirstName: {
                        value: "",
                        error: "",
                        showError: ""

                    },
                    LastName: {
                        value: "",
                        error: "",
                        showError: ""

                    },
                    Email: {
                        value: "",
                        error: "",
                        showError: ""

                    }
                }
            ]
        }
    },
    [namespacers.addSupplier("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }

    },
})


const reducer = combineReducers({
    list: listReducer,
    editSupplier: editSupplierReducer,
    addSupplier: addSupplierReducer,
})

export default reducer;
